import BigPanel from "../../components/BigPanel/BigPanel";
import "./Links.css";

function Links() {
  const sources = [
    {
      file: "clean-office-hero.jpg",
      title: "Clean Office",
      source: "Adobe Stock - AboutLife",
      asset: "514204609",
      href: "https://stock.adobe.com/de/search?k=clean+office&search_type=usertyped&asset_id=514204609"
    },
    {
      file: "clean-blue-glove.jpg",
      title: "Cleaning Gloves",
      source: "Adobe Stock - Vadym",
      asset: "1536565887",
      href: "https://stock.adobe.com/de/search?k=clean+office&search_type=usertyped&asset_id=1536565887"
    },
    {
      file: "clean-planning.jpg",
      title: "Team Cleaning Plan",
      source: "Adobe Stock - Photographee.eu",
      asset: "106220551",
      href: "https://stock.adobe.com/de/search?filters%5Bcontent_type%3Aphoto%5D=1&k=Geb%C3%A4udereinigung+Team+Planung+B%C3%BCro&asset_id=106220551"
    },
    {
      file: "clean-modern-office.jpg",
      title: "Modern Clean Office",
      source: "Adobe Stock - Victor zastol'skiy",
      asset: "210620329",
      href: "https://stock.adobe.com/de/search?k=clean+office&search_type=usertyped&asset_id=210620329"
    },
    {
      file: "clean-reception.jpg",
      title: "Clean Reception Area",
      source: "Adobe Stock - The Origin 33",
      asset: "1748385219",
      href: "https://stock.adobe.com/de/search?k=clean+reception&search_type=usertyped&asset_id=1748385219"
    },
    {
      file: "clean-staircase.jpg",
      title: "Marmortreppe mit Edelstahlgeländer",
      source: "iStock - Hanna Tor",
      asset: "2228762649",
      href: "https://www.istockphoto.com/fr/photo/int%C3%A9rieur-moderne-avec-un-escalier-en-marbre-%C3%A9l%C3%A9gant-et-une-balustrade-en-acier-gm2228762649-644528311"
    }
  ];

  const partners = [
    {
      name: "Bayern-Prospekte",
      description:
        "Prospektverteil-Agentur mit Schwerpunkt auf Bayern und dem süddeutschen Raum. Die Verteilung erfolgt regional, deutschlandweit sowie in angrenzenden Ländern.",
      phone: "0152 3371 9399",
      href: "https://www.bayern-prospekte.de",
      logo: "bayern_prospekte.jpg"
    },
    {
      name: "Prospekt Verteilung Christian Schweiger e.K.",
      description:
        "Spezialisiertes Prospektverteil-Unternehmen für Stadtgebiete und Landkreise rund um München, Augsburg, Ingolstadt, Regensburg und Nürnberg.",
      phone: "0152 337 193 99",
      href: "https://www.prospekt-verteilung-schweiger.de",
      logo: "prospektverteilung_schweiger.jpg"
    },
    {
      name: "Tierschutzverein München e.V.",
      description:
        "Gemeinnütziger Verein zur Betreuung und Pflege herrenloser Tiere im Raum München. Betreiber des Tierheims München in München-Riem/Trudering.",
      phone: "089 9210 000",
      href: "https://www.tierschutzverein-muenchen.de",
      logo: "tierschutzverein_muenchen.jpg"
    }
  ];

  return (
    <BigPanel title="Links">
      <div className="links-partners">
        <h3>Befreundete Firmen & Institutionen</h3>

        <div className="links-partners-list">
          {partners.map((p, idx) => (
            <div className="links-partner-item" key={idx}>
              <div className="links-partner-info">
                <p className="partner-title">{p.name}</p>
                <p>{p.description}</p>

                <p className="partner-meta">
                  Telefon: {p.phone} ·
                  <a
                    href={p.href}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {p.href.replace("https://", "").replace("http://", "")}
                  </a>
                </p>
              </div>

              <div className="links-partner-logoWrap" aria-hidden="true">
                <img
                  src={`/pictures/${p.logo}`}
                  alt={`${p.name} Logo`}
                  className="links-partner-logo"
                  loading="lazy"
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="links-list">
              <h3>Bilderquellen und Hinweise</h3>
        {sources.map((img, index) => (
          <div className="links-item" key={index}>
            <img
              src={`/pictures/${img.file}`}
              alt={img.title}
              className="links-img"
            />

            <div className="links-info">
              <p className="links-file">{img.file}</p>
              <p>{img.title}</p>
              <p>{img.source}</p>
              <p>Image ID: {img.asset}</p>
            </div>
          </div>
        ))}
      </div>
    </BigPanel>
  );
}

export default Links;
